import { isEmpty, CopySaveModal, useNotifier } from "lcm-iot-commons";
import { useIntl } from "react-intl";

type OwnProps = {
  recoveryCodes?: string[];
  show: boolean;
  onClose: $TSFixMeFunction;
};

const defaultProps: Partial<OwnProps> = {
  recoveryCodes: undefined,
};

type Props = OwnProps & typeof defaultProps;

export default function RecoveryCodesModal({
  recoveryCodes,
  show,
  onClose,
}: Props) {
  const intl = useIntl();
  const notifier = useNotifier();

  /* istanbul ignore next */
  const onSave = () => {
    const data = new Blob([recoveryCodes ? recoveryCodes.join("\n") : ""], {
      type: "text/plain",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(data);
    link.setAttribute("download", "Netilion_Recovery_Codes.txt");
    document.body.appendChild(link);
    // start download of the file
    link.click();
    // clean up and remove link element
    link.parentNode?.removeChild(link);
  };

  const onCopy = () => {
    notifier.showSuccess(
      intl.formatMessage({ id: "mfa.recovery_codes.copy_successful" }),
    );
  };

  const renderRecoveryCodes = () => {
    const recoveryCodesListItems = isEmpty(recoveryCodes)
      ? null
      : recoveryCodes?.map((recoveryCode: $TSFixMe) => (
          <li key={recoveryCode}>{recoveryCode}</li>
        ));

    return (
      <div>
        <div>
          <span>
            {intl.formatMessage({
              id: "mfa.recovery_codes.change.notification_1",
            })}
          </span>
        </div>
        <div className="space-before">
          <span>
            {intl.formatMessage({
              id: "mfa.recovery_codes.change.notification_2",
            })}
          </span>
        </div>
        <ul className="mfa-modal">{recoveryCodesListItems}</ul>
      </div>
    );
  };

  return show ? (
    <CopySaveModal
      // @ts-expect-error TS(2322) FIXME: Type '{ id: string; showClose: true; show: true; t... Remove this comment to see the full error message
      id="copy-save-recovery-codes"
      showClose
      show={show}
      title={intl.formatMessage({ id: "mfa.recovery_codes" })}
      message={renderRecoveryCodes()}
      onSave={() => onSave()}
      copyValues={recoveryCodes?.join("\n")}
      onCopyValue={() => onCopy()}
      onClose={() => onClose()}
    />
  ) : null;
}

RecoveryCodesModal.defaultProps = defaultProps;
